import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import {
  View,
  TextInput,
  Pressable,
  Platform,
  DeviceEventEmitter,
  Keyboard,
  BackHandler,
} from "react-native";
import RNAndroidSmsRetriever from "react-native-android-sms-retriever";
import Text from "@components/CustomText";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { useDispatch, useSelector } from "react-redux";
import { actions as walletActions } from "@reducers/oldWalletReducer";
import BankImage from "@assets/svg/WithdrawMoney/Bank";
import SubmitButton from "@components/Button";
import RightStraightArrow from "@assets/svg/RightStraightArrow";
import {
  deleteFundAccount,
  getWalletOtp,
  setPrimaryFundAccount,
} from "@services/api";
import analytics from "@services/analytics";
import { ACCOUNT_DELETED, ACCOUNT_ADDED } from "@constants/analyticsEvents";
import useCountdownTimer from "@hooks/useCountdown";
import ModalLoader from "@components/ModalLoader";
import { STATE_STATUS } from "@reducers/actionTypes";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import useCustomAlert from "@hooks/useCustomAlert";
import colors from "@constants/color";

import t from "@constants/localization";

const PATH = "screens/VerifyAccount";

const VerifyAccount = (props) => {
  const { route, navigation } = props;

  const dispatch = useDispatch();
  const wallet = useSelector((s) => s.wallet);
  const firstInput = useRef();
  const secondInput = useRef();
  const thirdInput = useRef();
  const fourthInput = useRef();

  const [firstInputVal, setFirstInputVal] = useState();
  const [secondInputVal, setSecondInputVal] = useState();
  const [thirdInputVal, setThirdInputVal] = useState();
  const [fourthInputVal, setFourthInputVal] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchFundAccounts = () => dispatch(walletActions.fetchFundAccounts());

  const { countdown, startCountdown, resetCountdown, isCountdownRunning } =
    useCountdownTimer({
      timer: 1000 * 30,
    });

  const [displayAlertgoingBack] = useCustomAlert({
    title: "",
    subTitle: t(`${PATH}/doYouWantToCancelVerification`),
    cancelable: true,
    okText: t(`${PATH}/yes`),
    onOkay: () => navigation.navigate("WithDrawGullakMoney"),
    cancelText: t(`${PATH}/no`),
    onCancel: () => null,
  });

  const [displayWrongOtpAlert] = useCustomAlert({
    title: "",
    subTitle: t(`${PATH}/checkOTP`),
    cancelable: true,
    okText: t(`${PATH}/yes`),
    showCancel: false,
  });

  // useLayoutEffect(() => {
  //   if (Platform.OS === "android") {
  //     RNAndroidSmsRetriever.startSmsRetriever();
  //     DeviceEventEmitter.addListener("smsRetrievedSuccess", (event) => {
  //       console.log("event message", event.message);
  //       if (event.message) {
  //         const reg = /(otp - \d{4})/i;
  //         const parsedOtp = event.message.match(reg)[0].match(/\d{4}/)[0];
  //         if (parsedOtp && parsedOtp.length === 4) {
  //           // setOtp(parsedOtp);
  //           otpSetter(parsedOtp);
  //           if (
  //             fourthInput &&
  //             fourthInput.current &&
  //             fourthInput.current.focus
  //           ) {
  //             fourthInput.current.focus();
  //           }
  //           DeviceEventEmitter.removeListener("smsRetrievedSuccess", null);
  //         }
  //       }
  //     });
  //   }
  //   () => {
  //     DeviceEventEmitter.removeListener("smsRetrievedSuccess", null);
  //   };
  // }, []);

  useEffect(() => {
    startCountdown();
    return () => {
      resetCountdown();
    };
  }, [startCountdown, resetCountdown]);

  useEffect(() => {
    const backAction = () => {
      displayAlertgoingBack();
      return true;
    };

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction,
    );

    return () => backHandler.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (wallet.createFundAccountStatus === STATE_STATUS.CREATE_FAILED) {
      // reset otp fields
      setFirstInputVal(null);
      setSecondInputVal(null);
      setThirdInputVal(null);
      setFourthInputVal(null);
      firstInput.current.focus();
    }
  }, [wallet.createFundAccountStatus]);

  const inputeMapping = [
    {
      ref: firstInput,
      next: secondInput,
      prev: null,
      value: firstInputVal,
      setValue: setFirstInputVal,
    },
    {
      ref: secondInput,
      prev: firstInput,
      next: thirdInput,
      value: secondInputVal,
      setValue: setSecondInputVal,
    },
    {
      ref: thirdInput,
      prev: secondInput,
      next: fourthInput,
      value: thirdInputVal,
      setValue: setThirdInputVal,
    },
    {
      ref: fourthInput,
      prev: thirdInput,
      next: null,
      value: fourthInputVal,
      setValue: setFourthInputVal,
    },
  ];

  const renderCard = () => {
    const { item } = route.params;
    const { user_name, account_type, upi_address, account_number, name } = item;
    return (
      <View
        style={{
          backgroundColor: "white",
          borderRadius: 6,
          padding: 16,
          flexDirection: "row",
        }}
      >
        <View
          style={{
            justifyContent: "center",
            paddingRight: 10,
          }}
        >
          {account_type === "vpa" ? (
            <UpiImage upi_address={upi_address} />
          ) : (
            <BankImage />
          )}
        </View>
        <View>
          <Text style={{ fontSize: 16 }}>
            {user_name ?? name ?? upi_address}
          </Text>
          <Text variant="body_text_3" style={{ color: "rgba(0,0,0,0.56)" }}>
            {upi_address ?? renderMaskedAccountNumber(account_number)}
          </Text>
        </View>
      </View>
    );
  };

  const renderSubTitle = () => {
    const {
      item: { account_number },
      type,
    } = route.params;
    if (type === "create") {
      return (
        <Text>
          {`${t(`${PATH}/new`)} ${
            account_number ? t(`${PATH}/bankAcc`) : "UPI"
          } ${t(`${PATH}/toAddEnterOTP`)}`}
        </Text>
      );
    } else if (type === "set_primary") {
      return <Text>{t(`${PATH}/toSetPrimaryEnterOTP`)}</Text>;
    } else {
      return (
        <Text>
          {`${t(`${PATH}/your`)} ${
            account_number ? t(`${PATH}/bankAcc`) : "UPI"
          } ${t(`${PATH}/toRemoveEnterOTP`)}`}
        </Text>
      );
    }
  };

  const renderMaskedAccountNumber = (value) => {
    if (!value) return;
    return (
      value.substring(0, 2) +
      value.substring(2, value.length - 2).replace(/\d/g, "X") +
      value.substring(value.length - 2)
    );
  };

  const renderOtpContainer = () => {
    return (
      <View style={{ flexDirection: "row", marginTop: 10 }}>
        {inputeMapping.map((input, index) => (
          <View
            style={{
              width: 60,
              height: 50,
              borderWidth: 1,
              borderColor: "rgba(0, 0, 0, 0.3)",
              borderRadius: 6,
              marginRight: 10,
            }}
          >
            <View
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TextInput
                testID="va-otp-input"
                value={input.value}
                autoFocus={index === 0 ? true : undefined}
                onChangeText={(v) => {
                  const nextRef = input.next;
                  let newValue = v;
                  if (input.value) {
                    newValue = v.slice(1);
                  }
                  input.setValue(newValue);
                  if (v) {
                    if (nextRef != null) nextRef.current.focus();
                    else Keyboard.dismiss();
                  }
                }}
                onKeyPress={({ nativeEvent: { key: keyValue } }) => {
                  const currentVal = input.value;
                  if (keyValue === "Backspace" && !currentVal) {
                    const prevRef = input.prev;
                    if (prevRef != null) prevRef.current.focus();
                  }
                }}
                ref={input.ref}
                // maxLength={1}
                keyboardType="phone-pad"
              />
            </View>
          </View>
        ))}
      </View>
    );
  };

  const handleAccountDelete = ({ otp }) => {
    const { item } = route.params;

    const payload = {
      edit: true,
      fund_account_id: item.id,
      otp,
      type: "delete",
    };
    dispatch(snackbarActions.resetSnackbar());

    deleteFundAccount(payload)
      .then(() => {
        const snackbarPayload = {
          message: t(`${PATH}/removedSuccessfully`),
          bottom: 0,
        };
        dispatch(snackbarActions.showSnackbar(snackbarPayload));
        setTimeout(() => {
          dispatch(snackbarActions.hideSnackbar());
        }, 4000);
        analytics.trackEvent(ACCOUNT_DELETED, {
          method: item.account_type,
        });

        setIsSubmitting(false);
        return fetchFundAccounts();
        // navigation.navigate("WithdrawMoney", { reload: true });
      })
      .then(() => {
        navigation.goBack();
      })
      .catch((e) => {
        console.log("delete account error", e.response.data);
        if (
          e.response.data &&
          e.response.data.error &&
          e.response.data.error === "INVALID_OTP"
        ) {
          setFirstInputVal(null);
          setSecondInputVal(null);
          setThirdInputVal(null);
          setFourthInputVal(null);
          firstInput.current.focus();
        }
        setIsSubmitting(false);
      });
  };
  const handleSetPrimaryAccount = ({ otp }) => {
    const { item } = route.params;
    const { id } = item;
    dispatch(snackbarActions.resetSnackbar());
    const payload = {
      fund_account_id: id,
      otp,
    };
    setPrimaryFundAccount(payload)
      .then(() => {
        const snackbarPayload = {
          message: t(`${PATH}/setAsPrimary`),
          bottom: 0,
        };
        dispatch(snackbarActions.showSnackbar(snackbarPayload));
        setTimeout(() => {
          dispatch(snackbarActions.hideSnackbar());
        }, 4000);

        setIsSubmitting(false);
        return fetchFundAccounts();
        // navigation.navigate("WithdrawMoney", { reload: true });
      })
      .then(() => {
        navigation.goBack();
      })
      .catch((e) => {
        console.log("Failed to set Primary account", e.response.data);
        if (
          e.response.data &&
          e.response.data.error &&
          e.response.data.error === "INVALID_OTP"
        ) {
          setFirstInputVal(null);
          setSecondInputVal(null);
          setThirdInputVal(null);
          setFourthInputVal(null);
          firstInput.current.focus();
        }
        setIsSubmitting(false);
      });
  };

  const handleAccountCreate = async ({ otp }) => {
    const { item } = route.params;
    console.log("handle account create item", item);

    const { account_type } = item;
    analytics.trackEvent(ACCOUNT_ADDED, {
      method: account_type,
    });
    if (account_type === "vpa") {
      await dispatch(
        walletActions.createFundAccountVpa({
          otp,
          type: "create",
          ...item,
        }),
      );
      setIsSubmitting(false);
    } else {
      await dispatch(
        walletActions.createFundAccountBank({
          otp,
          type: "create",
          ...item,
        }),
      );
      setIsSubmitting(false);
    }
    // if bank acc
  };

  const sendOtpToUser = () => {
    const { type, item } = route.params;
    getWalletOtp({ type, isDebug: __DEV__, ...item }).catch((err) =>
      console.warn(err),
    );
  };

  const otpSetter = (value) => {
    const otpArray = value.split("");
    const [a, b, c, d] =
      otpArray.length === 4 ? otpArray : new Array(4).fill("");
    setFirstInputVal(a);
    setSecondInputVal(b);
    setThirdInputVal(c);
    setFourthInputVal(d);
  };

  const onSubmit = () => {
    setIsSubmitting(true);
    const full_otp =
      firstInputVal + secondInputVal + thirdInputVal + fourthInputVal;
    const invalid = full_otp.split("").some((e) => Number.isNaN(Number(e)));
    if (invalid) {
      setIsSubmitting(false);
      return displayWrongOtpAlert();
    }
    const { type } = route.params;
    if (type === "delete") {
      handleAccountDelete({ otp: full_otp });
    } else if (type === "set_primary") {
      handleSetPrimaryAccount({ otp: full_otp });
    } else {
      handleAccountCreate({ otp: full_otp });
    }
  };

  const goingBackHandler = () => {
    return displayAlertgoingBack();
  };

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle={
          route.params.type === "create"
            ? t(`${PATH}/verifyAcc`)
            : t(`${PATH}/verify`)
        }
        navigation={navigation}
        route={route}
        alwaysEnable={true}
        goingBackHandler={goingBackHandler}
      />
      <ModalLoader
        loading={wallet.createFundAccountStatus === STATE_STATUS.CREATING}
      />

      <View style={{ paddingHorizontal: 16, marginTop: 20 }}>
        {renderCard()}
        <View style={{ marginTop: 30, paddingLeft: 5 }}>
          {renderSubTitle()}
          <View style={{ flexDirection: "row", marginTop: 10 }}>
            {renderOtpContainer()}
          </View>
          <View
            style={{
              marginVertical: 16,
              flexDirection: "row",
              position: "relative",
            }}
          >
            <Text variant="body_text_2">
              00:
              {isCountdownRunning
                ? `${countdown / 1000}`.length === 1
                  ? `0${countdown / 1000}`
                  : countdown / 1000
                : "00"}
            </Text>
            <Pressable
              testID="va-resend-otp"
              style={{ position: "absolute", left: 45 }}
              disabled={isCountdownRunning}
              hitSlop={{ top: 20, bottom: 20, left: 10, right: 10 }}
              onPress={() => {
                // if (firstDigitRef) {
                //   setOtp("");
                //   firstDigitRef.current.focus();
                // }
                setFirstInputVal(null);
                setSecondInputVal(null);
                setThirdInputVal(null);
                setFourthInputVal(null);
                resetCountdown();
                startCountdown();
                sendOtpToUser();
                setIsSubmitting(false);
              }}
            >
              <Text
                variant="body_text_4"
                style={{
                  color: !isCountdownRunning ? "#E40046" : "rgba(0,0,0,0.36)",
                  // marginLeft: 7,
                }}
              >
                {t(`${PATH}/resend`)}
              </Text>
            </Pressable>
          </View>
          <SubmitButton
            btnText={t(`${PATH}/verify`)}
            disabled={
              !(
                firstInputVal &&
                secondInputVal &&
                thirdInputVal &&
                fourthInputVal
              )
            }
            borderRadius={10}
            containerStyle={{ marginTop: 30 }}
            isSubmitting={isSubmitting}
            IconRight={<RightStraightArrow style={{ marginLeft: 10 }} />}
            onPress={onSubmit}
          />
        </View>
      </View>
    </View>
  );
};

export default VerifyAccount;

const UpiImage = ({ upi_address }) => (
  <View
    style={{
      justifyContent: "center",
      alignItems: "center",
      width: 40,
      height: 40,
      borderRadius: 100,
      backgroundColor: colors.accountIcon,
    }}
  >
    <Text variant="body_text_2" style={{ color: "#fff" }}>
      {upi_address.charAt(0).toUpperCase()}
    </Text>
  </View>
);
